/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AuditLogsSuccessResponseResponse,
    EmailLogSuccessResponseResponse,
    EmailLogsSuccessResponseResponse,
    EmailTesterSuccessResponseResponse,
    GetAuditLogsParams,
    GetEmailLogsParams,
    GetEmailTesterParams,
    RequestStatusResponseResponse,
    ResendEmailBody,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Get audit logs matching the filters
 */
export const getAuditLogs = (params?: GetAuditLogsParams, signal?: AbortSignal) => {
    return customInstance<AuditLogsSuccessResponseResponse>({
        url: `/auditlog`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetAuditLogsQueryKey = (params?: GetAuditLogsParams) => {
    return [`/auditlog`, ...(params ? [params] : [])] as const;
};

export const getGetAuditLogsQueryOptions = <
    TData = Awaited<ReturnType<typeof getAuditLogs>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetAuditLogsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getAuditLogs>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAuditLogsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditLogs>>> = ({ signal }) =>
        getAuditLogs(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getAuditLogs>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditLogs>>>;
export type GetAuditLogsQueryError = APIErrorResponseResponse;

/**
 * @summary Get audit logs matching the filters
 */

export function useGetAuditLogs<
    TData = Awaited<ReturnType<typeof getAuditLogs>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetAuditLogsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getAuditLogs>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetAuditLogsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get audit log details for a specific booking
 */
export const getBookingAuditLogs = (bookingId: number, signal?: AbortSignal) => {
    return customInstance<AuditLogsSuccessResponseResponse>({
        url: `/auditlog/${bookingId}`,
        method: 'GET',
        signal,
    });
};

export const getGetBookingAuditLogsQueryKey = (bookingId?: number) => {
    return [`/auditlog/${bookingId}`] as const;
};

export const getGetBookingAuditLogsQueryOptions = <
    TData = Awaited<ReturnType<typeof getBookingAuditLogs>>,
    TError = APIErrorResponseResponse,
>(
    bookingId: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getBookingAuditLogs>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetBookingAuditLogsQueryKey(bookingId);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingAuditLogs>>> = ({ signal }) =>
        getBookingAuditLogs(bookingId, signal);

    return { queryKey, queryFn, enabled: !!bookingId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getBookingAuditLogs>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetBookingAuditLogsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getBookingAuditLogs>>
>;
export type GetBookingAuditLogsQueryError = APIErrorResponseResponse;

/**
 * @summary Get audit log details for a specific booking
 */

export function useGetBookingAuditLogs<
    TData = Awaited<ReturnType<typeof getBookingAuditLogs>>,
    TError = APIErrorResponseResponse,
>(
    bookingId: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getBookingAuditLogs>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetBookingAuditLogsQueryOptions(bookingId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get email logs matching the filters
 */
export const getEmailLogs = (params?: GetEmailLogsParams, signal?: AbortSignal) => {
    return customInstance<EmailLogsSuccessResponseResponse>({
        url: `/emaillog`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetEmailLogsQueryKey = (params?: GetEmailLogsParams) => {
    return [`/emaillog`, ...(params ? [params] : [])] as const;
};

export const getGetEmailLogsQueryOptions = <
    TData = Awaited<ReturnType<typeof getEmailLogs>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetEmailLogsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailLogs>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetEmailLogsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailLogs>>> = ({ signal }) =>
        getEmailLogs(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getEmailLogs>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetEmailLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailLogs>>>;
export type GetEmailLogsQueryError = APIErrorResponseResponse;

/**
 * @summary Get email logs matching the filters
 */

export function useGetEmailLogs<
    TData = Awaited<ReturnType<typeof getEmailLogs>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetEmailLogsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailLogs>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetEmailLogsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Resend email
 */
export const resendEmail = (
    id: number,
    resendEmailBody?: ResendEmailBody,
    signal?: AbortSignal,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/emaillog/${id}`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: resendEmailBody,
        signal,
    });
};

export const getResendEmailMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof resendEmail>>,
        TError,
        { id: number; data: ResendEmailBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof resendEmail>>,
    TError,
    { id: number; data: ResendEmailBody },
    TContext
> => {
    const mutationKey = ['resendEmail'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof resendEmail>>,
        { id: number; data: ResendEmailBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return resendEmail(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ResendEmailMutationResult = NonNullable<Awaited<ReturnType<typeof resendEmail>>>;
export type ResendEmailMutationBody = ResendEmailBody;
export type ResendEmailMutationError = APIErrorResponseResponse;

/**
 * @summary Resend email
 */
export const useResendEmail = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof resendEmail>>,
        TError,
        { id: number; data: ResendEmailBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof resendEmail>>,
    TError,
    { id: number; data: ResendEmailBody },
    TContext
> => {
    const mutationOptions = getResendEmailMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get email log by ID
 */
export const getEmailLog = (id: number, signal?: AbortSignal) => {
    return customInstance<EmailLogSuccessResponseResponse>({
        url: `/emaillog/${id}`,
        method: 'GET',
        signal,
    });
};

export const getGetEmailLogQueryKey = (id?: number) => {
    return [`/emaillog/${id}`] as const;
};

export const getGetEmailLogQueryOptions = <
    TData = Awaited<ReturnType<typeof getEmailLog>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailLog>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetEmailLogQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailLog>>> = ({ signal }) =>
        getEmailLog(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getEmailLog>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetEmailLogQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailLog>>>;
export type GetEmailLogQueryError = APIErrorResponseResponse;

/**
 * @summary Get email log by ID
 */

export function useGetEmailLog<
    TData = Awaited<ReturnType<typeof getEmailLog>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailLog>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetEmailLogQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get email tester metadata and/or preview (superadmin only)
 */
export const getEmailTester = (params?: GetEmailTesterParams, signal?: AbortSignal) => {
    return customInstance<EmailTesterSuccessResponseResponse>({
        url: `/email-tester`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetEmailTesterQueryKey = (params?: GetEmailTesterParams) => {
    return [`/email-tester`, ...(params ? [params] : [])] as const;
};

export const getGetEmailTesterQueryOptions = <
    TData = Awaited<ReturnType<typeof getEmailTester>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetEmailTesterParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailTester>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetEmailTesterQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailTester>>> = ({ signal }) =>
        getEmailTester(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getEmailTester>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetEmailTesterQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailTester>>>;
export type GetEmailTesterQueryError = APIErrorResponseResponse;

/**
 * @summary Get email tester metadata and/or preview (superadmin only)
 */

export function useGetEmailTester<
    TData = Awaited<ReturnType<typeof getEmailTester>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetEmailTesterParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getEmailTester>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetEmailTesterQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}
